export const UserConsents = (json: IUserConsents): IUserConsentsModel => {
	const fromJSON = (json: IUserConsents) => {
		const { accept_terms, data_processing, electronic_invoices, loyalty_program, marketing_contact, ...rest } = json
		return {
			...rest,
			acceptTerms: accept_terms,
			dataProcessing: data_processing,
			electronicInvoices: electronic_invoices,
			loyaltyProgram: loyalty_program,
			marketingContact: marketing_contact,
		}
	}

	return { ...fromJSON(json) }
}

export const userConsentsToJSON = (obj: IUserConsentsModel): IUserConsents => {
	const { acceptTerms, dataProcessing, electronicInvoices, loyaltyProgram, marketingContact, ...rest } = obj
	return {
		accept_terms: acceptTerms,
		data_processing: dataProcessing,
		electronic_invoices: electronicInvoices,
		loyalty_program: loyaltyProgram,
		marketing_contact: marketingContact,
		...rest,
	}
}
